import React, { useState, useContext } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import atoms from "../../atoms";
import "./Header.scss";
import { TbLogout } from "react-icons/tb";
import service from "../../../api/services";
import { useToasts } from "react-toast-notifications";
import { BadgesCount, ShowActiveTab, StorePopup } from "../../../Context";
import { checkPermissionsInArray } from "../../../constants/utils";
import { AllPermissions } from "../../../constants/permission";
import LoginImage from "../../../assets/Images/specx_logo.jpg";
import { userLogout } from "../../../features/logout/index";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store/store";
import constant from "../../../constants/constant";
import { setSelectedCheckboxes } from "../../../features/productList/filter/checkboxSlice";
import { CartModal } from "./component/CartModal";
import { HeaderProps, NotificationCountProps } from "./interface";
import { RightSection } from "./component/RigthSection";
import { TabsPreview } from "./component/TabsPreview";
const { Image, Badge } = atoms;


const Header: React.FC<HeaderProps> = ({ storeList }) => {
  const dispatch: AppDispatch = useDispatch();
  const [cartPopup, setCartPopup] = useState(false);
  const [notificationCount, setNotificationCount] = useContext<any>(BadgesCount);

  const sales_count: any = localStorage?.getItem("sales_count");
  const authDetail: any = localStorage?.getItem("auth_details");
  const Auth_details = localStorage?.getItem("auth_details")
    ? JSON.parse(authDetail)
    : {};
  const token = Auth_details?.access_token;
  const navigate = useNavigate();
  const { addToast } = useToasts();
  const { activeTab }: any = useContext(ShowActiveTab);
  const logout = async () => {
    try {
      if (sales_count > 0) {
        setCartPopup(true);
      } else {
        let response = await service.auth.logout(token);
        if (response.status === 200) {
          dispatch(userLogout());
          addToast(response?.data?.message, {
            appearance: "success",
            autoDismiss: true,
            autoDismissTimeout: 3000,
          });
          localStorage.clear();
          navigate("/login");
        }
      }
    } catch (error: any) {
      console.log(error);
      addToast(error.response.data.message, {
        appearance: "error",
        autoDismiss: true,
        autoDismissTimeout: 3000,
      });
    }
  };

  const resetCheckboxes = () => {
    dispatch(
      setSelectedCheckboxes({
        brand: [],
        type: [],
        polarized: [],
        frame_materials: [],
        product_shapes: [],
        rim_type: [],
        features: [],
        gender: [],
        price: [],
        sw_color_list: [],
        lens_color: [],
        bridge_size: [],
        weight: [],
        glass_size: [],
        temple_size: [],
        period_use: [],
        pack_of_qty: [],
      })
    );
  };
  const handleNavClick = (path: string) => {
    resetCheckboxes();
    navigate(`/product/list?${path}`);
    localStorage.setItem("product_filter", path);
  };
  return (
    <>
      <div className="header-main d-flex justify-content-center">
        <nav
          className="navbar navbar-expand-xl header-nav"
          style={{ width: "1440px" }}
        >
          {/*INFO:- Specx-web Logo  */}
          <div className="d-flex gap-1 align-items-center">
            <button
              className="navbar-toggler shadow-none"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon fs-10" />
            </button>

            <div
              className="navbar-brand cursor-pointer nav-logo-width"
              onClick={() => navigate("/dashboard")}
            >
              <Image src={LoginImage} alt="" className="img-fluid logo" />
            </div>
          </div>
          {/* end */}

          {/* Started User Profile */}
          <div className="col-md-6 col-xl-3 d-flex justify-content-end nav-profile-div gap-1">
            <RightSection
              storeList={storeList}
              logout={logout}
              activeTab={activeTab}
              notificationCount={notificationCount}
            />
          </div>
          {/* end */}

          {/* INFO:- taps view */}
          <div
            className="col-xl-7 collapse navbar-collapse nav-tab-order d-xl-flex justify-content-center nav-list-scroll"
            id="navbarSupportedContent"
            style={{ zIndex: "10040" }}
          >
            <TabsPreview
              activeTab={activeTab}
              handleNavClick={handleNavClick}
              notificationCount={notificationCount}
              logout={logout}
            />
            <div
              className="navbar-collapse header-transparent-overlay"
              id="navbar-collapse"
              data-bs-toggle={window.innerWidth < 825 ? "collapse" : ""}
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            ></div>
          </div>
          {/* end */}
        </nav>
      </div>
      <div className="empty-div"></div>

      {/* INFO:- Modal of Warning popup of sales cart */}
      {cartPopup && (
        <CartModal
          setCartPopup={(value: boolean) => setCartPopup(value)}
          cartPopup={cartPopup}
        />
      )}
      {/* end */}
    </>
  );
};

export default Header;
